module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.33562/js/img/productIcons/SmartCrm_Ent.svg"